import { Breadcrumb, Checkbox } from "antd"
import React, { useEffect, useState } from "react"
import { equalsIgnoreCase } from "../../../helpers/StringHelper"
import { authorizeBankNoteSettlement, authorizeBankNotesProcessingDenominations, confirmBankNotesReceivedByCustomer, updateProcessingDenominations } from "../../../networking/NetworkingBankNotes"
import { getStyle, notFilledInputClass, notFilledSelectClass, regularInputClass, regularSelectClass } from "../../../styles/styles"
import AlertBox from "../../shared/AlertBox"
import NumberInput from "../../shared/NumberInput"
import { formatToCommaSeparateKeepMinus, formatToCurrency, formatToCurrencyWithScale } from "../../../helpers/FormatHelper"
import { useContext } from "react"
import PickAndPackContext from "./PickAndContext"
import { roundAmount } from "../../../helpers/BankNotesHelper"
import { getCurrentDateTime } from "../../../helpers/DateHelper"
import DynamicSelect from "../../shared/DynamicSelect"
import { Vault } from "lucide-react"
import { PrintConfirmation } from "../../tools/print/PrintLabel"

const formatValidSelect = (valid) => {
    return valid ? regularSelectClass : notFilledSelectClass;
}
const formatValidInput = (valid) => {
    return valid ? regularInputClass : notFilledInputClass;
}

const style = getStyle();

const denominationRowStyles = {
  inputStyle: { width: "100px", textAlign: "right", fontSize: "1.1rem" },
  processingRow: {
    display: "flex",
    gap: "0",
    important: true,
    width: "100%",
    marginRight: "1rem",
  },
  processingRowlgt1: {
    display: "flex",
    gap: "0",
    important: true,
    width: "100%",
    marginTop: "1rem",
    marginRight: "1rem",
  },
  processingRowHeader: {
    textAlign: "right",    
    paddingRight: "0.5rem",
    backgroundColor: "inherit",
    height: "30px",
    lineHeight: "30px",
    minWidth: "70px",
    //maxWidth: "90px"
  },
  processingRowHeaderCurrency: {
    textAlign: "left",
    fontSize: "1.2rem",
    paddingRight: "5rem",
    fontWeight: "bold"
  },
  processingRowCell: {
    minWidth: "60px",
    maxWidth: "100px",
    important: true,
    backgroundColor: "inherit",
    color: "inherit",
  },
  processingRowCellDisabled: {
    minWidth: "60px",
    maxWidth: "100px",
    important: true,    
    color: "inherit",
    },
  processingRowCellTotal: {
    important: true,
    minWidth: "60px",
    maxWidth: "150px",
    border: "0px",
    textAlign: "right",
    fontSize: "1.1rem",
    fontWeight: "600",
    backgroundColor: "inherit",
    color: "inherit",
  },
  dummyUkInput: {
    height: "30px",
  },
  rowSeparator: {
    color: "lightgray",
    height: "1px",
    important: true,
    width: "100%",
    marginTop: "1rem",
  },
};

const EditBnOrder = (props) => {

    const {
        lockedSide,
        bankNoteOrder,
        customerDenominations,
        lookUpTables,
        sellDeliveryStatusOptions,
        isBankNotesAdmin = false,
        vaultBalances,
        canViewInventoryBalances = false,
        reviewPurchaseOrders = false,
        toSetAsReceivedManually = false,
        reviewAndAuthorizeSellOrders = false,
        confirmationMessage,
        setConfirmationMessage,
        setLoading,
    } = useContext(PickAndPackContext);

    let deliveryOptions = lookUpTables[equalsIgnoreCase(lockedSide, 'Buy') ? 'BNDeliveryBuyStatus' : 'BNDeliverySellStatus'] || []

    const sellSide = equalsIgnoreCase(lockedSide, 'sell')
    const showOrdered = sellSide || isBankNotesAdmin

    if (equalsIgnoreCase(lockedSide, "Sell") && Array.isArray(sellDeliveryStatusOptions) && sellDeliveryStatusOptions.length > 0) {
        deliveryOptions = deliveryOptions.filter(
            (d) =>
                Array.isArray(sellDeliveryStatusOptions) &&
                sellDeliveryStatusOptions.includes(d.value)
        );
    }

    if(equalsIgnoreCase(bankNoteOrder.DeliveryStatus, "in progress")){
        deliveryOptions = deliveryOptions.filter(x => x.value.toLowerCase() !== "in transit");
    }

    const { orderNo, back, refreshSelectedOrder } = props

    const [deliveryStatus, setDeliveryStatus] = useState('')    
    const [customerId, setCustomerId] = useState(0)
    const [customerName, setCustomerName] = useState('')
    const [deliveryText, setDeliveryText] = useState('')

    const [saveMessageLabel] = useState('Save')    
    const [confirmSaveProcessedDenominations, setConfirmSaveProcessedDenominations] = useState({ show: false, title: '', message: '' })    
    const [confirmSetAsReadyToPay, setConfirmSetAsReadyToPay] = useState({ show: false, title: '', message: '' })    
    const [confirmSetAsReceivedManually, setConfirmSetAsReceivedManually] = useState({ show: false, title: '', message: '' })

    const [alertMessage, setAlertMessage] = useState({ show: false, title: '', message: '' })

    const [validations, setValidations] = useState({ deliveryStatus: true })
    const [noteConditions] = useState([{'name':'Mint','value':'Mint'}, {'name':'Out of circulation','value':'Out of circulation'}])

    useEffect(() => {
        if (bankNoteOrder && bankNoteOrder.BNOrderNo > 0) {
            setDeliveryStatus(bankNoteOrder.DeliveryStatus)
            setCustomerId(bankNoteOrder.CustomerId)
            setCustomerName(bankNoteOrder.Name)
            setDeliveryText(bankNoteOrder.DeliveryText)
            bankNoteOrder.OrderRows.forEach(row => {
                let totalProcessed = 0;
                if (reviewAndAuthorizeSellOrders) {
                    if (row.Denominations) {
                        row.Denominations.forEach(denomination => {
                            totalProcessed += denomination.AuthorizedNoNotes * denomination.DenominationValue
                        });
                    }
                } else {
                    if (row.ProcessedDenominations) {
                        row.ProcessedDenominations.forEach(denomination => {
                            totalProcessed += denomination.NoNotesProcessed * denomination.DenominationValue;
                        });
                    }
                }
                row.TotalProcessed = roundAmount(totalProcessed)
                row.TotalProcessedDiff = roundAmount(row.Amount - totalProcessed)
                row.TotalProcessedValid = row.TotalProcessed <= row.Amount

            })
            const currentUserId = localStorage.getItem('UserID');
            if (!reviewPurchaseOrders && !equalsIgnoreCase(currentUserId, bankNoteOrder.UpdatedBy)) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Warning',
                    message: 'The current order was previously modified by another user'
                })
            }
        }
    }, [bankNoteOrder])

    const validateDenominations = () => {
        const validateTotalProcessed = sellSide &&
            (equalsIgnoreCase(deliveryStatus, "completed") ||
                equalsIgnoreCase(deliveryStatus, "confirmed") ||
                equalsIgnoreCase(deliveryStatus, "in progress"));
        for (const row of bankNoteOrder.OrderRows) {
            if (validateTotalProcessed && row.TotalProcessed > row.Amount) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} cannot exceed the ordered amount ${formatToCurrencyWithScale(row.Amount, row.CurrencyID)}`)
                })
                return false
            }
            if (equalsIgnoreCase(deliveryStatus, 'completed') && row.TotalProcessed !== row.Amount) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} must match the ordered amount ${formatToCurrencyWithScale(row.Amount, row.CurrencyID)} 
                    to complete the order`)
                })
                return false
            }
            if (equalsIgnoreCase(deliveryStatus, "confirmed") && row.TotalProcessed === 0) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} must be greater than zero to confirm the order`)
                })
                return false
            }
            if (reviewAndAuthorizeSellOrders && row.TotalProcessed !== row.Amount) {
                setAlertMessage({
                    ...alertMessage, show: true, title: 'Error',
                    message: (`The total processed amount ${formatToCurrencyWithScale(row.TotalProcessed, row.CurrencyID)} 
                    for the currency ${row.CurrencyName} must match the ordered amount ${formatToCurrencyWithScale(row.Amount, row.CurrencyID)}`)
                })
                return false
            }
        }
        return true
    }

    const onSaveProcessedDenominations = () => {
        let message
        if (equalsIgnoreCase(deliveryStatus, 'pending')) {
            message = `Do you want to save the order ${orderNo} as Pending?. It will change to zero all denominations?`
        } else if (equalsIgnoreCase(deliveryStatus, 'in progress') && !equalsIgnoreCase(bankNoteOrder.DeliveryStatus, 'In progress')) {
            message = `Are you sure you want to set the Order ${orderNo} as In Progress?`
        }
        else {
            message = `Are you sure you want to set the Order ${orderNo} as ${deliveryStatus}?`
        }

        if (equalsIgnoreCase(lockedSide, 'Buy') && equalsIgnoreCase(deliveryStatus, "confirmed")) {
            for (const row of bankNoteOrder.OrderRows) {
                if (row.TotalProcessed !== row.Amount) {
                    message = 'The total processed amount does not match the ordered amount, do you want to continue?'
                    break;
                }
            }
        }

        const pickAndPackCompleted = equalsIgnoreCase(deliveryStatus, 'completed')
        let validateForCompletion = pickAndPackCompleted && validateRequiredFields() && validateDenominations()

        if (pickAndPackCompleted && !validateForCompletion) {
            return
        }

        if (validateDenominations()) {
            setConfirmSaveProcessedDenominations({ ...confirmSaveProcessedDenominations, show: true, title: 'Confirm', message: message })
        }
    }

    const onConfirmSaveProcessedDenominations = async () => {
        closeConfirmSaveProcessedDenominations()
        bankNoteOrder.DeliveryStatus = deliveryStatus
        if (equalsIgnoreCase(lockedSide, 'Buy') && equalsIgnoreCase(deliveryStatus, "confirmed")) {
            bankNoteOrder.ReceivedOn = getCurrentDateTime()
        }

        setLoading(true)
        const response = await updateProcessingDenominations(orderNo, bankNoteOrder, bankNoteOrder.UpdateToken)
        setLoading(false)
        console.log('onConfirmSaveProcessedDenominations ', response)

        if (response !== undefined && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Success', message: `Order ${orderNo} saved successfully` })
            const list = [];
            list.push({BNOrderNo:orderNo});
            if(equalsIgnoreCase(deliveryStatus, "Completed")){
                PrintConfirmation(list);
            }
            refreshSelectedOrder()
            back()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    const closeConfirmSaveProcessedDenominations = () => {
        setConfirmSaveProcessedDenominations({ ...confirmSaveProcessedDenominations, show: false, title: '', message: '' })
    }
    

    const closeAlertMessage = () => {
        setAlertMessage({ ...alertMessage, show: false, title: '', message: '' })
    }

    const validateRequiredFields = () => {
        const currentValidations = updateAndGetValidations()
        return currentValidations.deliveryStatus
    }

    const updateAndGetValidations = (validateReferenceNo) => {
        const currentValidations = {
            ...validations,
            deliveryStatus: (deliveryStatus !== undefined && deliveryStatus !== null && deliveryStatus !== '' && deliveryStatus !== '-1')
        }
        setValidations(currentValidations)
        return currentValidations
    }

    const updateWorkingOrder = (rowNum, currencyId, denNum, denDesc, newValue, denValue) => {
        const orderRow = bankNoteOrder.OrderRows.filter(r => r.ItemNo === rowNum && r.CurrencyID === currencyId)
        if (Array.isArray(orderRow) && orderRow[0].ItemNo > 0) {

            if (orderRow[0].ProcessedDenominations === undefined || orderRow[0].ProcessedDenominations === null) {
                orderRow[0].ProcessedDenominations = []
            }

            if (reviewAndAuthorizeSellOrders) {
                const denominations = orderRow[0].Denominations.filter(r => r.DenominationDescription === denDesc)
                const inStockCurrDeno = vaultBalances.filter(b => b.Currency === currencyId && b['Denomination Description'] === denDesc)

                if (Array.isArray(denominations) && denominations.length > 0 && denominations[0].ItemNo > 0) {
                    denominations[0].AuthorizedNoNotes = Number(newValue)
                    denominations[0].InventoryValue = Array.isArray(inStockCurrDeno) && inStockCurrDeno.length > 0 ? inStockCurrDeno[0]['In Stock'] : 0
                    denominations[0].VbUpdateToken = Array.isArray(inStockCurrDeno) && inStockCurrDeno.length > 0 ? inStockCurrDeno[0]['VbUpdateToken'] : ''
                }
                else {
                    orderRow[0].Denominations.push({
                        ItemNo: rowNum,
                        DenominationDescription: denDesc,
                        DenominationValue: denValue,
                        AuthorizedNoNotes: Number(newValue),
                        InventoryValue: Array.isArray(inStockCurrDeno) && inStockCurrDeno.length > 0 ? inStockCurrDeno[0]['In Stock'] : 0,
                        VbUpdateToken: Array.isArray(inStockCurrDeno) && inStockCurrDeno.length > 0 ? inStockCurrDeno[0]['VbUpdateToken'] : ''
                    })
                }
            } else {
                const processedDenomination = orderRow[0].ProcessedDenominations.filter(r => r.DenominationDescription === denDesc)

                if (Array.isArray(processedDenomination) && processedDenomination.length > 0 && processedDenomination[0].ItemNo > 0) {
                    processedDenomination[0].NoNotesProcessed = Number(newValue)
                }
                else {
                    orderRow[0].ProcessedDenominations.push({
                        ItemNo: rowNum,
                        DenominationDescription: denDesc,
                        DenominationValue: denValue,
                        NoNotesProcessed: newValue
                    })
                }
            }

            let totalProcessed = 0;

            if (reviewAndAuthorizeSellOrders) {
                if (orderRow[0].Denominations) {
                    orderRow[0].Denominations.forEach(denomination => {
                        totalProcessed += denomination.AuthorizedNoNotes * denomination.DenominationValue;
                    });
                }
            } else {
                if (orderRow[0].ProcessedDenominations) {
                    orderRow[0].ProcessedDenominations.forEach(denomination => {
                        totalProcessed += denomination.NoNotesProcessed * denomination.DenominationValue;
                    });
                }
            }

            orderRow[0].TotalProcessed = roundAmount(totalProcessed)
            orderRow[0].TotalProcessedDiff = roundAmount(orderRow[0].Amount - totalProcessed)
            orderRow[0].TotalProcessedValid = orderRow[0].TotalProcessed <= orderRow[0].Amount
        }
    }

    const onSetReadyToPay = () => {
        let message = `Are you sure you want to set the Order ${orderNo} as Ready to pay?`
        setConfirmSetAsReadyToPay({ ...confirmSetAsReadyToPay, show: true, title: 'Confirm', message: message })
    }

    const closeConfirmSetAsReadyToPay = () => {
        setConfirmSetAsReadyToPay({ ...confirmSetAsReadyToPay, show: false, title: '', message: '' })
    }

    const onSetReceivedManually = () => {
        let message = `Are you sure you want to set the Order ${orderNo} as Received?`
        setConfirmSetAsReceivedManually({ ...confirmSetAsReceivedManually, show: true, title: 'Confirm', message: message })
    }

    const closeConfirmSetAsReceivedManually = () => {
        setConfirmSetAsReceivedManually({ ...confirmSetAsReceivedManually, show: false, title: '', message: '' })
    }

    const onConfirmSetAsReadyToPay = async () => {

        closeConfirmSetAsReadyToPay()

        setLoading(true)
        const response = await authorizeBankNoteSettlement(orderNo, bankNoteOrder, bankNoteOrder.UpdateToken)
        setLoading(false)
        console.log('onConfirmSetAsReadyToPay ', response)
        
        if (response !== undefined && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Success', message: `Order ${orderNo} saved successfully` })
            refreshSelectedOrder()
            back()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    const onConfirmSetAsReceivedManually = async () => {
        closeConfirmSetAsReceivedManually()
        
        setLoading(true)
        const response = await confirmBankNotesReceivedByCustomer(orderNo, bankNoteOrder, bankNoteOrder.UpdateToken)
        setLoading(false)
        console.log('onConfirmSetAsReceivedManually ', response)

        if (response !== undefined && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Success', message: `Order ${orderNo} saved successfully` })
            refreshSelectedOrder()
            back()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    } 

    const onSaveAndAuthorizeSellOrders = async () => {
        if (!validateDenominations()) {
            return;
        }

        const isValidateVaultBalance = validateVaultBalance();
        if (!isValidateVaultBalance.valid) {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: isValidateVaultBalance.errors.join('\n')
            })
            return;
        }


        setConfirmationMessage({
            ...confirmationMessage, show: true, title: 'Confirm',
            message: 'Please confirm all the information is Ok before the authorization. Do you want to proceed',
            callback: saveAndAuthorize
        }
        )
    }

    const validateVaultBalance = () => {
        // ---- Parse helper: turn "1,725" / "" / "-100" into a safe number ----
        const parseNumber = (val) => {
            if (val === null || val === undefined || val === "") return 0;
            const cleaned = String(val).replace(/,/g, "").trim();
            const n = Number(cleaned);
            return Number.isNaN(n) ? 0 : n;
        };

        // =========================================================================
        // CHECK 1: PER-DENOMINATION (hard validation)
        // =========================================================================

        // Stock count per "CURRENCY_DENOM" key
        const stockByDenom = {};
        vaultBalances.forEach((item) => {
            const currency = item["Currency"];
            const denom = String(item["Denomination Description"]).trim();
            const key = `${currency}_${denom}`;
            stockByDenom[key] = parseNumber(item["In Stock"]);
        });

        // Authorized notes requested per "CURRENCY_DENOM" key (aggregated across order rows)
        const requestedByDenom = {}; // key -> { currency, denom, totalAuthorized }

        (bankNoteOrder.OrderRows || []).forEach((row) => {
            const currency = row.CurrencyID;
            (row.Denominations || []).forEach((d) => {
                const denom = String(d.DenominationDescription).trim();
                const key = `${currency}_${denom}`;
                const authorized = Number(d.AuthorizedNoNotes) || 0;

                if (authorized > 0) {
                    if (!requestedByDenom[key]) {
                        requestedByDenom[key] = { currency, denom, totalAuthorized: 0 };
                    }
                    requestedByDenom[key].totalAuthorized += authorized;
                }
            });
        });

        const errors = [];
        const denominationDetails = [];

        Object.values(requestedByDenom).forEach(({ currency, denom, totalAuthorized }) => {
            const key = `${currency}_${denom}`;
            const available = stockByDenom.hasOwnProperty(key) ? stockByDenom[key] : null;

            if (available === null) {
                errors.push(`No stock information found for ${currency} ${denom} denomination.`);
                denominationDetails.push({ currency, denom, totalAuthorized, available: null, ok: false });
                return;
            }

            const ok = totalAuthorized <= available;
            if (!ok) {
                errors.push(
                    `Authorized notes for ${currency} ${denom} (${totalAuthorized} notes) ` +
                    `exceed available stock (${available} notes).`
                );
            }

            denominationDetails.push({ currency, denom, totalAuthorized, available, ok });
        });

        // =========================================================================
        // CHECK 2: PER-CURRENCY TOTAL (informational summary only)
        // =========================================================================

        const stockValueByCurrency = {};
        vaultBalances.forEach((item) => {
            const currency = item["Currency"];
            const denomValue = parseNumber(item["Denomination Description"]);
            const stockCount = parseNumber(item["In Stock"]);
            stockValueByCurrency[currency] = (stockValueByCurrency[currency] || 0) + stockCount * denomValue;
        });

        const authorizedValueByCurrency = {};
        (bankNoteOrder.OrderRows || []).forEach((row) => {
            const currency = row.CurrencyID;
            (row.Denominations || []).forEach((d) => {
                const authorizedCount = Number(d.AuthorizedNoNotes) || 0;
                if (authorizedCount) {
                    const denomValue = parseNumber(d.DenominationDescription);
                    authorizedValueByCurrency[currency] =
                        (authorizedValueByCurrency[currency] || 0) + authorizedCount * denomValue;
                }
            });
        });

        const currencyTotals = Object.entries(authorizedValueByCurrency).map(
            ([currency, totalAuthorizedValue]) => {
                const totalStockValue = stockValueByCurrency.hasOwnProperty(currency)
                    ? stockValueByCurrency[currency]
                    : null;
                const ok = totalStockValue === null ? null : totalAuthorizedValue <= totalStockValue;
                return { currency, totalAuthorizedValue, totalStockValue, ok };
            }
        );

        // =========================================================================
        // Result — `valid` is driven ONLY by the per-denomination check
        // =========================================================================

        return {
            valid: errors.length === 0,
            errors,
            denominationDetails, // hard validation, per denomination
            currencyTotals,       // informational summary, per currency
        };
    }

    const saveAndAuthorize = async () => {

        setLoading(true)
        const response = await authorizeBankNotesProcessingDenominations(orderNo, bankNoteOrder, bankNoteOrder.UpdateToken)
        setLoading(false)
        console.log('authorizeBankNotesProcessingDenominations ', response)

        if (response !== undefined && response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Success', message: `Order ${orderNo} saved successfully` })
            refreshSelectedOrder()
            back()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }

    }

    const OrderRow = ({ orderRow, rowId }) => {

        const [refresh, setRefresh] = useState(false);
        const userCanEditDenominations = equalsIgnoreCase(lockedSide, 'Buy') || reviewAndAuthorizeSellOrders || reviewPurchaseOrders

        let editDenominationsControlDetail = []
        let editDenominationsControlTotal = []

        let customerCurrencyDenominations = customerDenominations.filter(c => c.CurrencyID === orderRow.CurrencyID)

        if (Array.isArray(customerCurrencyDenominations) && customerCurrencyDenominations.length > 0 && Array.isArray(customerCurrencyDenominations[0].Denominations)) {

            const allowEdition = equalsIgnoreCase(bankNoteOrder.DeliveryStatus, 'In progress') || reviewAndAuthorizeSellOrders
            
            editDenominationsControlDetail = customerCurrencyDenominations[0].Denominations.map((d, idx) => {

                let value = 0
                let orderedValue = 0

                let inStock = 0   
                if (canViewInventoryBalances) {
                    let inStockCurrDeno = vaultBalances.filter(b => b.Currency === orderRow.CurrencyID && b['Denomination Description'] === d.DenominationDescription)
                    if (Array.isArray(inStockCurrDeno) && inStockCurrDeno.length > 0) {
                        inStock = inStockCurrDeno[0]['In Stock'] || 0
                    }
                }

                if (orderRow.ProcessedDenominations) {

                    const processed = orderRow.ProcessedDenominations.filter(pd => pd.DenominationDescription === d.DenominationDescription)
                    if (Array.isArray(processed) && processed.length > 0) {
                        value = processed[0].NoNotesProcessed
                    }
                }
                if (orderRow.Denominations) {
                    const processed = orderRow.Denominations.filter(pd => pd.DenominationDescription === d.DenominationDescription)
                    if (Array.isArray(processed) && processed.length > 0) {
                        orderedValue = equalsIgnoreCase(lockedSide, 'Sell') && !reviewAndAuthorizeSellOrders ? processed[0].AuthorizedNoNotes : processed[0].NoNotes
                    }
                    if (reviewAndAuthorizeSellOrders && Array.isArray(processed) && processed.length > 0) {
                        value = processed[0].AuthorizedNoNotes
                    }
                }
                else {
                    orderedValue = 0
                }

                if (!userCanEditDenominations) {
                    value = orderedValue
                    updateWorkingOrder(orderRow.ItemNo, orderRow.CurrencyID, d.ItemNo, d.DenominationDescription, value, d.DenominationValue)
                }

                return <div
                    id={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                    key={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}>
                    <div
                        id={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        style={denominationRowStyles.processingRowHeader}>
                        {d.DenominationDescription}</div>
                    {canViewInventoryBalances && <div id={`eo-div-in-details-rows-${rowId}-den-${idx}-stock-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-stock-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-stock-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-stock-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={inStock === 0 ? '' : formatToCommaSeparateKeepMinus(inStock)}
                            onChange={() => { }}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellDisabled}
                            scale={0}
                            negative={true}
                        />
                    </div>
                    }
                    {showOrdered && <div id={`eo-div-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-ordered-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Integer"
                            value={orderedValue === 0 ? '' : orderedValue}
                            onChange={() => { }}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellDisabled}
                        />
                    </div>
                    }

                    {userCanEditDenominations && <div id={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`} >
                        {/* *** Here we edit *** */}
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Integer"
                            value={value === 0 ? '' : value}
                            onChange={event => {
                                if (event.target.value === '' || event.target.value === null || event.target.value === undefined) {
                                    return;
                                }
                                updateWorkingOrder(orderRow.ItemNo, orderRow.CurrencyID, d.ItemNo, d.DenominationDescription, event.target.value, d.DenominationValue)
                            }}
                            disabled={!allowEdition}
                            onBlur={() => {
                                setRefresh(refresh => !refresh)
                            }}
                            style={denominationRowStyles.processingRowCell}
                        />
                    </div>}

                </div>
            })

            editDenominationsControlDetail.unshift(<div id={`eo-root-details-rows-${rowId}-den-indicator-edit`} key={`eo-root-details-rows-${rowId}-den-indicator-edit`} >
                <div style={denominationRowStyles.processingRowHeader}>&nbsp;</div>
                {canViewInventoryBalances && <div style={denominationRowStyles.processingRowHeader}>{'In Stock'}</div>}
                {showOrdered && <div style={denominationRowStyles.processingRowHeader}>{orderRow.Denominations ?
                    ((equalsIgnoreCase(lockedSide, 'Sell') && !reviewAndAuthorizeSellOrders) ? 'Authorized' : 'Ordered') :
                    'Mixed Notes'}</div>}
                {userCanEditDenominations && <div style={denominationRowStyles.processingRowHeader}>{reviewAndAuthorizeSellOrders ? 'Authorized' : sellSide ? 'Shipped' : 'Received'}</div>}
                <div style={denominationRowStyles.processingRowHeader}>&nbsp;</div>
            </div>);

            editDenominationsControlDetail.unshift(<div id={`eo-root-details-rows-${rowId}-den-indicatorcurrency-edit`} key={`eo-root-details-rows-${rowId}-den-indicatorcurrency-edit`} >
                <div style={denominationRowStyles.processingRowHeaderCurrency}>&nbsp;</div>
                <div style={denominationRowStyles.processingRowHeaderCurrency}>{orderRow.CurrencyID}</div>
                {userCanEditDenominations && <div>
                    <label>Condition: {orderRow.NoteConditions}</label>
                </div>}
                {userCanEditDenominations && <div>
                    <Checkbox id={`eo-root-details-rows-${rowId}-den-mixed-edit`} key={`eo-root-details-rows-${rowId}-den-mixed-edit`} checked={orderRow.MixedDenominations} >{'Mixed'}</Checkbox>
                </div>}
            </div>);

            let inStockTotal = 0
            if (canViewInventoryBalances) {
                let inStockCurr = vaultBalances.filter(b => b.Currency === orderRow.CurrencyID)
                if (Array.isArray(inStockCurr) && inStockCurr.length > 0) {
                    inStockTotal = inStockCurr.reduce((acc, curr) => acc + (Number(curr['In Stock']) || 0) * (Number(curr['Denomination Description']) || 0), 0)
                }
            }

            editDenominationsControlTotal.push(
                <div id={`eo-root-details-rows-${rowId}-den-totalprocessed-edit`} key={`eo-root-details-rows-${rowId}-den-totalprocessed-edit`} >
                    <div
                        id={`eo-div-details-rows-${rowId}-den-totalprocessed-edit`} key={`eo-div-details-rows-${rowId}-den-totalprocessed-edit`}
                        style={denominationRowStyles.processingRowHeader}
                    >Total</div>
                    {canViewInventoryBalances && <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-instock-edit`} key={`eo-in-details-rows-${rowId}-den-instock-edit`}
                            className={formatValidInput(true)}
                            type="Currency"
                            value={formatToCommaSeparateKeepMinus(inStockTotal || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                            scale={2}
                            negative={true}
                        />
                    </div>}
                    {showOrdered && <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-totalordered-edit`} key={`eo-in-details-rows-${rowId}-den-totalordered-edit`}
                            className={formatValidInput(true)}
                            type="Currency"
                            value={formatToCurrency(orderRow.Amount || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                        />
                    </div>}
                    {userCanEditDenominations && <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-totalprocessed-edit`} key={`eo-in-details-rows-${rowId}-den-totalprocessed-edit`}
                            className={formatValidInput(true)}
                            type="Currency"
                            value={formatToCurrency(orderRow.TotalProcessed || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                        />
                    </div>}
                    <div style={denominationRowStyles.dummyUkInput}>&nbsp;</div>
                </div>
            )

            userCanEditDenominations && showOrdered && editDenominationsControlTotal.push(
                <div id={`eo-root-details-rows-${rowId}-den-totaldiff-edit`} key={`eo-root-details-rows-${rowId}-den-totaldiff-edit`} >
                    <div style={denominationRowStyles.processingRowHeader}>Difference</div>
                    {canViewInventoryBalances && <div style={denominationRowStyles.dummyUkInput}>&nbsp;</div>}
                    <div style={denominationRowStyles.dummyUkInput}>&nbsp;</div>
                    <div>
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-totalprocessed-diff`} key={`eo-in-details-rows-${rowId}-den-totalprocessed-diff`}
                            className={formatValidInput(orderRow.TotalProcessedValid === undefined ? true : orderRow.TotalProcessedValid)}
                            type="Currency"
                            value={formatToCurrency(orderRow.TotalProcessedDiff || 0)}
                            disabled={true}
                            style={denominationRowStyles.processingRowCellTotal}
                        />
                    </div>
                    <div style={denominationRowStyles.dummyUkInput}>&nbsp;</div>
                </div>
            )

        }

        return <tr>
            <td><div style={rowId === 0 ? denominationRowStyles.processingRow : denominationRowStyles.processingRowlgt1}>
                {editDenominationsControlDetail}
            </div></td>

            <td><div style={rowId === 0 ? denominationRowStyles.processingRow : denominationRowStyles.processingRowlgt1}>
                {editDenominationsControlTotal}
            </div></td>
        </tr>

    }

    const OrderRowsView = ({ order }) => {
        const orderRows = [];
        const denominationCount = order.OrderRows ? order.OrderRows.length : 0;
        if (order.OrderRows) {
            order.OrderRows.forEach((order, index) => {
                if (order) {
                    if (0 < index && index < denominationCount) {                        
                        orderRows.push(<tr>
                            <td colSpan={2}><hr key={`eo-hr-details-den-rows-${index}`} style={denominationRowStyles.rowSeparator} /></td>
                        </tr>)
                    }
                    orderRows.push(<OrderRow id={`eo-div-details-den-rows-${index}`} key={`eo-div-details-den-rows-${index}`}
                        orderRow={order} rowId={index} />)
                }
            })
        }
        return <div id='eo-div-details-rows' key='eo-div-details-rows' className="uk-grid" style={{ display: "flex", justifyContent: "left", marginLeft: "10px" }}>
            <table>
                <tbody>
                    <tr>
                        <th></th>
                        <th></th>
                    </tr>
                    {orderRows}
                </tbody>
            </table>
        </div>;
    }

    let disableDeliveryStatusControl = reviewPurchaseOrders || toSetAsReceivedManually || reviewAndAuthorizeSellOrders
    let allowSaveDenominations = !reviewPurchaseOrders && !toSetAsReceivedManually && !reviewAndAuthorizeSellOrders
    let allowSetReadyToPay = reviewPurchaseOrders
    let allowReceivedManually = toSetAsReceivedManually

    let settlementInfoFields = []
    if (allowSetReadyToPay) {
        settlementInfoFields.push(
            <div className="uk-width-1-1">
                <label className="uk-form-label" >Total</label>
                <div className="uk-form-controls">
                    <input id="bo-in-totalnetorder"
                        disabled
                        className="uk-input"
                        value={formatToCurrencyWithScale(bankNoteOrder.TotalNetOrder, bankNoteOrder.SettlementCurrencyID) + ' ' + bankNoteOrder.SettlementCurrencyID} />
                </div>
            </div>
        )

        settlementInfoFields.push(
            <div className="uk-width-1-2">
                <label className="uk-form-label" >Settlement Instrument</label>
                <div className="uk-form-controls">
                    <input id="bo-in-settlementinstrument"
                        disabled
                        className="uk-input"
                        value={bankNoteOrder.SettlementInstrument} />
                </div>
            </div>
        )
        settlementInfoFields.push(
            <div className="uk-width-1-2">
                <label className="uk-form-label" >Settlement Method</label>
                <div className="uk-form-controls">
                    <input id="bo-in-settlementmethod"
                        disabled
                        className="uk-input"
                        value={bankNoteOrder.SettlementMethod} />
                </div>
            </div>
        )
    }   

    let breadCrumbLabel = `Orders - ${equalsIgnoreCase(lockedSide, 'Sell') ? 'To shipped' : 'To receive'}`
    if (reviewAndAuthorizeSellOrders) {
        breadCrumbLabel = `Review and Authorize Sell Order`
    }
    else if (reviewPurchaseOrders) {
        breadCrumbLabel = `Review Purchase Order`
    } else if (toSetAsReceivedManually) {
        breadCrumbLabel = `Set as Received Manually`
    }

    return <div>
        <div className="breadcrumb-div">
            <Breadcrumb separator=">">
                <Breadcrumb.Item className={'breadcrumb-item'} onClick={back}>{breadCrumbLabel}</Breadcrumb.Item>
                <Breadcrumb.Item className="breadcrumb-item-bold">{`Order No. ${bankNoteOrder.BNOrderNo}`}</Breadcrumb.Item>
            </Breadcrumb>
        </div>
        <div>
            <div className="uk-grid uk-margin uk-width-1-2">
                <div className="uk-width-1-1">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label" >Account</label></div>
                    <div className="uk-width-1-1" >
                        <input id='bo-in-customerid'
                            disabled
                            className="uk-input"
                            value={`${customerName} - ${customerId}`} />
                    </div>
                </div>

                {equalsIgnoreCase(lockedSide, "Sell") && <div className="uk-width-1-1">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label" >Delivery To</label></div>
                    <div className="uk-width-1-1" >
                        <input id='bo-in-deliveryto'
                            disabled
                            className="uk-input"
                            value={deliveryText} />
                    </div>
                </div>}

                <div className="uk-width-1-1">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label" >Delivery Status</label></div>
                    <div className="uk-form-controls">
                        <select id="bo-select-deliverystatus"
                            className={formatValidSelect(validations.deliveryStatus)}
                            value={deliveryStatus}
                            onChange={(e) => {
                                setDeliveryStatus(e.target.value);
                            }}
                            disabled={disableDeliveryStatusControl}                      
                        >
                            {deliveryOptions.map((type) => (
                                <option
                                    key={`status-option-${type.value}`}
                                    value={type.value}>{`${type.name}`}</option>
                            ))}

                        </select>
                    </div>
                </div>           
                {settlementInfoFields}
            </div>
            <div id='eo-div-details' key='eo-div-details'>
                <h3 style={style.subTitleStyle2} >Currencies - {lockedSide === 'Sell' ? 'We Sell' : 'We Buy'}</h3>
            </div>
            
            {bankNoteOrder && <OrderRowsView order={bankNoteOrder} />}
            <hr />
            <div className="uk-width-1-2 uk-margin">
                <button id="eo-b-saveinprogress-order" className="uk-button uk-button-green" type="button"
                    onClick={onSaveProcessedDenominations} hidden={!allowSaveDenominations}>{saveMessageLabel}</button>
                <button id="eo-b-set-readytopay-order" className="uk-button uk-button-green" type="button"
                    onClick={onSetReadyToPay} hidden={!allowSetReadyToPay} >Set as Ready to Pay</button>
                <button id="eo-b-set-receivedmanually-order" className="uk-button uk-button-green" type="button"
                    onClick={onSetReceivedManually} hidden={!allowReceivedManually} >Set as Received Manually</button>

                <button id="eo-b-save-authorize-order" className="uk-button uk-button-green" type="button"
                    onClick={onSaveAndAuthorizeSellOrders} hidden={!reviewAndAuthorizeSellOrders}>Save and Set Authorized</button>

            </div>
        </div>        

        <AlertBox id="ab-warning-confirmSaveProcessedDenominations" open={confirmSaveProcessedDenominations.show} onClose={closeConfirmSaveProcessedDenominations}
            title={confirmSaveProcessedDenominations.title} message={confirmSaveProcessedDenominations.message} type="Yes/No"
            yesClick={onConfirmSaveProcessedDenominations} noClick={closeConfirmSaveProcessedDenominations} />
        <AlertBox id="ab-warning-confirmSetAsReadyToPay" open={confirmSetAsReadyToPay.show} onClose={closeConfirmSetAsReadyToPay}
            title={confirmSetAsReadyToPay.title} message={confirmSetAsReadyToPay.message} type="Yes/No"
            yesClick={onConfirmSetAsReadyToPay} noClick={closeConfirmSetAsReadyToPay} />
        <AlertBox id="ab-warning-confirmSetAsReceivedManually" open={confirmSetAsReceivedManually.show} onClose={closeConfirmSetAsReceivedManually}
            title={confirmSetAsReceivedManually.title} message={confirmSetAsReceivedManually.message} type="Yes/No"
            yesClick={onConfirmSetAsReceivedManually} noClick={closeConfirmSetAsReceivedManually} />  
        <AlertBox id="ab-alert-1" type="Ok" open={alertMessage.show} title={alertMessage.title} message={alertMessage.message}
            okClick={closeAlertMessage} onClose={closeAlertMessage} />

    </div>
}

export default EditBnOrder